import React, { Component } from 'react';

//componentes
import CorreosI from './correosInterno'

class Index extends Component {

    render(){
        return(
            <div>
                <CorreosI />
            </div>
        );
    }
}
export default Index;